/** Whether a 510(k)-exempt package's saved outcome claims exemption: the ONE test the page's
 *  heading (DossierResultRenderer) and its banner (The510kExemptRenderer) both read, so they always
 *  agree. Fail-safe: anything but "exempt" (any case, spaces round it trimmed), a missing or
 *  non-text outcome included, is NOT exempt, so the page never falsely asserts exemption. LOCKSTEP
 *  with the server's `is_exempt_outcome` in `app/dossier/usa/rules/exempt_layout.py`, which the
 *  disclaimer box, the Word file and the PDF read. */
export function is510kExemptOutcome(dossier: Record<string, unknown>): boolean {
  const outcome = dossier['exemption_outcome'];
  return typeof outcome === 'string' && outcome.trim().toLowerCase() === 'exempt';
}
